export default __webpack_public_path__ + "static/media/question-mark-circle.7d427b26.png";